

<template>
  <div class="font" >
    <b-container fluid>
      <b-row>
        <b-col cols='12' class='mx-auto mt-4 ml-3 font-org-right-blue'>
          <h4><b-icon icon="files" class='mr-2'></b-icon>ユーザーインポート</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols='9' class='mx-auto mt-4'>
          <b-row>
              <h4>ユーザーの情報を一括で登録できます。フォーマットに沿ったCSVファイルを選択してください</h4>
              <input type="file" placeholder="CSVファイルを選択してください" @change="onFileChange"/>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import moment from 'moment';
import axios from 'axios';
export default {
  components: {
  },
  data() {
      return{
        idToken: localStorage.idToken,
        csv_file: ""
      }
  },
  methods:{
    format_date(d){
      return moment(d).format("YYYY/MM/DD")
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      this.csv_file = files[0];

      const formData = new FormData();
      formData.append('file', this.csv_file);

      this.$swal.fire({
        icon: 'question',
        title: 'インポートを実行しますか？',
        showCancelButton: true,
        confirmButtonText: '実行',
        cancelButtonText: 'キャンセル',
      }).then(() => {
            this.$swal.showLoading(); 

            console.log("-----")
            console.log("----")
            axios
              .post(process.env.VUE_APP_API + "/api/agcy/agency_users", formData, {headers: {'Authorization': 'Bearer ' + this.idToken}})
              .then((r) => {
                console.log(r)
                this.$swal({
                  title: 'インポートが完了しました',
                  icon: 'success',
                  confirmButtonClass: 'btn btn-info',
                  confirmButtonText: 'OK',
                })
              }).catch((error) => {
            console.log("aaaaaaaaaa")
                // 通信が失敗した場合の処理
                console.log(error)
                this.$swal.fire({
                  title: 'エラー',
                  html: 'データの取得に失敗しました。<br>もう一度お試しください',
                  icon: 'error',
                });
              });
        })
    },
  },
  mounted(){
          this.$store.commit('setLoading', false)
  },
}

</script>
<style type="text/css" scoped="">
.tablewrapper{
  overflow-x: scroll;
}
.table-scroll{
  border-collapse: collapse;
  white-space: nowrap;
}
</style>
